(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discount-popup"] && !Shopify.designMode) return;
  try {
    
  const STORAGE_KEY = 'vasha-discount-popup-dismissed';

  // Theme editor: ignore the "already dismissed" flag and the delay, otherwise the
  // popup is untestable — it would show once and never again for that browser.
  const isDesignMode = () => Boolean(window.Shopify && window.Shopify.designMode);

  function getSection() {
    return document.getElementById('discount-popup-section');
  }

  function openPopup(section, { persistDismissal }) {
    section.showDialog();

    if (persistDismissal) {
      section.addEventListener(
        'dialog:close',
        () => localStorage.setItem(STORAGE_KEY, Date.now().toString()),
        { once: true }
      );
    }
  }

  function initDiscountPopup() {
    const section = getSection();
    if (!section) return;

    if (isDesignMode()) {
      openPopup(section, { persistDismissal: false });
      return;
    }

    if (localStorage.getItem(STORAGE_KEY)) return;

    const parsedDelay = parseInt(section.dataset.delay, 10);
    const DELAY_MS = (Number.isFinite(parsedDelay) ? parsedDelay : 5) * 1000;

    setTimeout(() => {
      if (localStorage.getItem(STORAGE_KEY)) return;
      openPopup(section, { persistDismissal: true });
    }, DELAY_MS);
  }

  if (document.readyState === 'complete') {
    initDiscountPopup();
  } else {
    window.addEventListener('load', initDiscountPopup);
  }

  // Reopen whenever the merchant selects the section or edits one of its blocks,
  // so it stays on screen while they work on it.
  for (const evt of ['shopify:section:select', 'shopify:section:load', 'shopify:block:select']) {
    document.addEventListener(evt, (event) => {
      const section = getSection();
      if (!section) return;
      if (event.target && !event.target.contains(section) && event.target !== section) return;
      openPopup(section, { persistDismissal: false });
    });
  }

  document.addEventListener('shopify:section:deselect', () => {
    const section = getSection();
    if (section && isDesignMode()) section.closeDialog();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const HOTSPOT = '[data-shoppable-hotspot]';
    const TRIGGER = '.shoppable-hero__hotspot-trigger';
    const CARD = '.shoppable-hero__card';

    function reset(hotspot) {
      hotspot.classList.remove('is-open', 'is-flipped-y');
      hotspot.style.removeProperty('--sh-card-shift');
      hotspot.querySelector(TRIGGER)?.setAttribute('aria-expanded', 'false');
    }

    function closeAll(except) {
      document.querySelectorAll(`${HOTSPOT}.is-open`).forEach((hotspot) => {
        if (hotspot !== except) reset(hotspot);
      });
    }

    /* Keep the card inside the hero: nudge it horizontally, flip it above if needed. */
    function place(hotspot) {
      const card = hotspot.querySelector(CARD);
      const hero = hotspot.closest('.shoppable-hero');
      if (!card || !hero) return;

      const margin = 12;
      const bounds = hero.getBoundingClientRect();
      let rect = card.getBoundingClientRect();

      let shift = 0;
      if (rect.right > bounds.right - margin) shift = bounds.right - margin - rect.right;
      else if (rect.left < bounds.left + margin) shift = bounds.left + margin - rect.left;
      if (shift) hotspot.style.setProperty('--sh-card-shift', `${Math.round(shift)}px`);

      rect = card.getBoundingClientRect();
      const spaceAbove = hotspot.getBoundingClientRect().top - bounds.top;
      if (rect.bottom > bounds.bottom - margin && spaceAbove > rect.height + margin) {
        hotspot.classList.add('is-flipped-y');
      }
    }

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(TRIGGER);

      if (trigger) {
        const hotspot = trigger.closest(HOTSPOT);
        const wasOpen = hotspot.classList.contains('is-open');
        closeAll(hotspot);
        reset(hotspot);
        if (!wasOpen) {
          hotspot.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          place(hotspot);
        }
        return;
      }

      if (event.target.closest(CARD)) return;

      /* A click meant to dismiss an open card must not also follow the hero link */
      const link = event.target.closest('.shoppable-hero__link');
      if (link && link.closest('.shoppable-hero')?.querySelector(`${HOTSPOT}.is-open`)) {
        event.preventDefault();
      }

      closeAll();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });

    window.addEventListener('resize', () => closeAll());
  })();

  } catch(e) { console.error(e); }
})();
})();
